import React from 'react';
import CnDetailInfoView from './cn-detail-info';
class CnDetailInfo extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    render() {
        return React.createElement(CnDetailInfoView, { ref: this.ref, ...this.props });
    }
}
CnDetailInfo.displayName = 'CnDetailInfo';
export default CnDetailInfo;
export { CnDetailInfo };
